require('./static/css/prism-base2tone-morning-dark.css')
